import {createReducer} from "redux-act";
import {
	clearLeaderboard,
	fetchLeaderboard,
	fetchLeaderboardFailed,
	fetchLeaderboardSuccess,
	setLeaderboardFilters,
} from "modules/actions";
import {RequestState} from "modules/enums";
import {IRanking, IRankingFilters} from "modules/types";
import {concat} from "lodash";

export interface IRankingsResponse {
	rankings: IRanking[];
	user: IRanking | null;
	nextPage: boolean;
}

interface ILeaguesState {
	leaderboard: IRankingsResponse;
	leaderboardFilters: IRankingFilters;
	requestState: RequestState;
	error: string | null;
}

const initial: ILeaguesState = {
	leaderboard: {
		rankings: [],
		user: null,
		nextPage: false,
	},
	leaderboardFilters: {
		country: 0,
		startId: 0,
		stage: "overall",
	},
	requestState: RequestState.IDLE,
	error: null,
};

export const leaderboard = createReducer({}, initial)
	.on(fetchLeaderboard, (state) => ({
		...state,
		requestState: RequestState.Requested,
	}))
	.on(fetchLeaderboardSuccess, (state, payload) => ({
		...state,
		leaderboard: {
			rankings: concat(state.leaderboard.rankings, payload.rankings),
			user: payload.user,
			nextPage: payload.nextPage,
		},
		requestState: RequestState.Received,
	}))
	.on(fetchLeaderboardFailed, (state, error) => ({
		...state,
		requestState: RequestState.Error,
		error,
	}))
	.on(clearLeaderboard, (state) => ({
		...state,
		leaderboard: {
			rankings: [],
			user: null,
			nextPage: false,
		},
	}))
	.on(setLeaderboardFilters, (state, filters) => ({
		...state,
		leaderboardFilters: filters,
	}));
